'use client';

import { create } from 'zustand';

export type SignInStep =
  | 'start'
  | 'verifications'
  | 'choose'
  | 'choose-strategy'
  | 'forgot-password'
  | 'reset-password'
  | 'callback';

type FirstFactorStrategy = 'password' | 'email_code';
type FirstFactorMethod = 'email' | 'google';
type ForgotPasswordOrigin = 'start-email-form' | 'verifications';
export type SecondFactorStrategy = 'email_code' | 'totp' | 'backup_code';

interface SignInFlowState {
  experimentIdentifier: string;
  experimentPassword: string;
  firstFactorMethod: FirstFactorMethod;
  firstFactorStrategy: FirstFactorStrategy;
  forgotPasswordOrigin: ForgotPasswordOrigin | null;
  identifier: string;
  isFormVisible: boolean;
  isRedirecting: boolean;
  secondFactorStrategy: SecondFactorStrategy;
  step: SignInStep;
}

interface SignInFlowActions {
  onChange: (args: Partial<SignInFlowState>) => void;
  reset: () => void;
}

type SignInFlowStore = SignInFlowState & SignInFlowActions;

const initSignInFlowStore = (): SignInFlowState => ({
  step: 'start',
  identifier: '',
  experimentIdentifier: '',
  experimentPassword: '',
  isFormVisible: false,
  forgotPasswordOrigin: null,
  isRedirecting: false,
  firstFactorMethod: 'email',
  firstFactorStrategy: 'password',
  secondFactorStrategy: 'email_code',
});

export const useSignInFlowStore = create<SignInFlowStore>()((set) => ({
  ...initSignInFlowStore(),
  onChange: (args) => set((state) => ({ ...state, ...args })),
  reset: () => set(initSignInFlowStore()),
}));
